import "./header.css"
import logo from 'assets/images/others/logo.png'
import discordImg from 'assets/images/others/discord.svg'
import twitterImg from 'assets/images/others/twitter.svg'
import igImg from 'assets/images/others/instagram.svg'
import {Link} from 'react-router-dom'
import {Slide} from 'react-reveal'

const Header = () => {
    return (
        <Slide top>
        <header id="web-header2">
            <div className="header-container2">
                <Link to='/' className="header-logo2">
                    <img className="header-main-logo"
                        loading="lazy"
                        src={logo}
                        alt="" />
                    <span className="header-text-logo">Business Ape Club</span>
                </Link>
                <div className="header-nav">
                    <a href="https://discord.gg/eqWG6CuyqC" target="_blank" rel="noopener noreferrer" className="header-btns">
                        <img src={discordImg} alt="" />
                    </a>
                    <a href="https://twitter.com/BusinessApeClub" target="_blank" rel="noopener noreferrer" className="header-btns">
                        <img src={twitterImg} alt="" />
                    </a>
                    <a href="https://www.instagram.com/businessapeclub/" target="_blank" rel="noopener noreferrer" className="header-btns">
                        <img src={igImg} alt="" />
                    </a>
                    <a href="https://discord.gg/eqWG6CuyqC" target="_blank" rel="noopener noreferrer" className="header-btns discord-btn">
                        Join Discord <img src={discordImg} alt="" />
                    </a>
                </div>
            </div>
            
        </header>
        </Slide>
    )
}

export default Header
